import ExerciseBase from "@tt-app/components/exercise/ExerciseBase";
import { FlatExerciseListDetails, nextExerciseRouter } from "@tt-app/utils";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";

interface Data {
  answer: string;
  answers?: any;
  allAttempts?: any;
  answerSubmitted: boolean;
  audioDecoderPlayer?: AudioDecoderPlayer;
  currentPageIndex: number;
  currentQuestionIndex?: number;
  exerciseResult?: any;
  feedbackFormVisible?: boolean;
  logId?: number;
  review?: any;
  selectedOption?: any;
  selectedOptions?: any;
  showQuestionUI: boolean;
  trophyVisible: boolean;
}

interface Methods {
  closeQuiz: () => void;
  incrementPage: () => void;
  initializeQuestionUI: () => void;
  logExerciseResponse?: () => void;
  logSkippedExercise?: () => void;
  onActionBtnClick: (action: string) => void;
  reinitializeQuiz: () => void;
  restartExerciseWithSelection?: () => void;
  scrollToTop?: () => void;
  startExercise?: () => void;
}

interface Computed {
  assignmentId?: string;
  courseUuid: string;
  isTrophyPage: boolean;
  nextExercise: FlatExerciseListDetails;
}

export default ExerciseBase.extend<Data, Methods, Computed>({
  name: "QuizBase",
  methods: {
    closeQuiz() {
      this.nav.requireExitConfirmation = false;
      this.exit();
    },
    incrementPage() {
      this.currentPageIndex = this.currentPageIndex + 1;
      if (!this.isTrophyPage) {
        this.answerSubmitted = false;
        this.scrollToTop && this.scrollToTop();
        this.answer = "";
        this.selectedOption = undefined;
      }
    },
    onActionBtnClick(action) {
      const actions: { [action: string]: () => void } = {
        NEXT_EXERCISE: () => {
          this.audioDecoderPlayer && this.audioDecoderPlayer.stop();
          nextExerciseRouter({
            assignmentId: this.assignmentId,
            courseUuid: this.courseUuid,
            ...this.nextExercise
          });
        },
        CLOSE: () => {
          this.closeQuiz();
        },
        NEXT: async () => {
          this.logExerciseResponse && (await this.logExerciseResponse());
          this.audioDecoderPlayer && this.audioDecoderPlayer.stop();
          this.initializeQuestionUI();
          this.incrementPage();
        },
        RETRY: () => {
          this.initializeQuestionUI();
          this.reinitializeQuiz();
        },
        RETRY_WITH_SELECTED: () => {
          this.initializeQuestionUI();
          this.restartExerciseWithSelection && this.restartExerciseWithSelection();
        },
        REVIEW: () => {
          this.incrementPage();
        },
        SKIP: async () => {
          this.logSkippedExercise && (await this.logSkippedExercise());
          this.audioDecoderPlayer && this.audioDecoderPlayer.stop();
          this.incrementPage();
        }
      };

      const fn = actions[action];

      fn && fn();
    },
    initializeQuestionUI() {
      this.currentQuestionIndex = 0;
      this.showQuestionUI = false;
    },
    async reinitializeQuiz() {
      this.answers = {};
      this.allAttempts = {};
      this.answerSubmitted = false;
      this.currentPageIndex = 0;
      this.scrollToTop && this.scrollToTop();
      this.exerciseResult = undefined;
      this.logId = undefined;
      this.review = {};
      this.selectedOption = undefined;
      this.selectedOptions = {};
      this.startExercise && (await this.startExercise());
      this.feedbackFormVisible = true;
    }
  }
});
